export const INTERVALS_FILTER_TEST_ID = 'intervals-filter'

export const OWNERS_FILTER_TEST_ID = 'owners-filter'

export const GROUPS_FILTER_TEST_ID = 'groups-filter'

export const MORE_BUTTON_TEST_ID = 'additional-filters-trigger'

export const LEVELS_FILTER_TEST_ID = 'levels-filter'

export const STATUS_FILTER_TEST_ID = 'status-filter'

export const START_DATE_FILTER_TEST_ID = 'start-date-filter'

export const DUE_DATE_FILTER_TEST_ID = 'due-date-filter'

export const LAST_GRADE_UPDATE_FILTER_TEST_ID = 'last-grade-update-filter'

export const LABELS_FILTER_TEST_ID = 'labels-filter'

export const STAKEHOLDERS_FILTER_TEST_ID = 'stakeholders-filter'

export const LAST_COMMENT_FILTER_TEST_ID = 'last-comment-filter'

export const LAST_CHECKIN_FILTER_TEST_ID = 'last-checkin-filter'

export const WORKSPACE_FILTER_TEST_ID = 'workspace-filter'
